// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var DragDrop$ReactHooksTemplate = require("./DragDrop.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var LogicForm$ReactHooksTemplate = require("./LogicForm.res.js");

function LogicPage(props) {
  var updateSurvey = props.updateSurvey;
  var survey = props.survey;
  var match = React.useState(function (param) {
        
      });
  var setActiveQuestion = match[1];
  var activeQuestion = match[0];
  var removeLogics = function (logic$p) {
    Curry._1(updateSurvey, Survey$ReactHooksTemplate.setDeletedLogics(Survey$ReactHooksTemplate.setLogics(survey, Belt_List.keep(survey.logics, (function (x) {
                        return Caml_obj.notequal(x, logic$p);
                      }))), Belt_List.add(survey.deletedLogics, logic$p)));
  };
  var reorderLogics = function (sourceIndex, targetIndex) {
    var draggedLogic = Belt_List.get(Survey$ReactHooksTemplate.logics(survey), sourceIndex);
    if (draggedLogic === undefined) {
      return ;
    }
    var logic = Caml_option.valFromOption(draggedLogic);
    var logics = Belt_List.keepWithIndex(Survey$ReactHooksTemplate.logics(survey), (function (x, param) {
            return Caml_obj.notequal(x, logic);
          }));
    var match = Belt_List.splitAt(logics, targetIndex);
    if (match === undefined) {
      return ;
    }
    var reorderedlogics = Belt_List.concat(Belt_List.concat(match[0], {
              hd: logic,
              tl: /* [] */0
            }), match[1]);
    var updtaeLogics = List.mapi((function (i, x) {
            return Logic$ReactHooksTemplate.setPriority(x, i + 1 | 0);
          }), reorderedlogics);
    Curry._1(updateSurvey, Survey$ReactHooksTemplate.setLogics(survey, updtaeLogics));
  };
  var match$1 = DragDrop$ReactHooksTemplate.useDragDrop(reorderLogics);
  var getBlurClass = match$1[3];
  var handleDragDrop = match$1[2];
  var handleDragOver = match$1[1];
  var handleDragStart = match$1[0];
  var hasNoThankYous = List.length(survey.thankYouList) === 0;
  var lastQuestionIndex = List.length(Survey$ReactHooksTemplate.questions(survey)) - 1 | 0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: "Logic",
                            className: "w-48-px h-40-px py-2 border-b-2 border-pigmentblue text-lg font-semibold"
                          }),
                      className: "w-110-px h-40-px"
                    }),
                $$Array.of_list(List.mapi((function (index, x) {
                            var isLastQuestion = index === lastQuestionIndex;
                            var disableAddLogic = isLastQuestion && hasNoThankYous;
                            var logicCount = List.length(List.filter(function (i) {
                                        var y = Logic$ReactHooksTemplate.trigger(i);
                                        switch (y.TAG) {
                                          case "Question" :
                                              return Caml_obj.equal(Question$ReactHooksTemplate.uuid(y._0), Question$ReactHooksTemplate.uuid(x));
                                          case "Welcome" :
                                          case "Survey" :
                                              return false;
                                          
                                        }
                                      })(Survey$ReactHooksTemplate.logics(survey)));
                            return JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: String(index + 1 | 0) + ".",
                                                                className: "mr-2"
                                                              }),
                                                          JsxRuntime.jsx("div", {
                                                                children: Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(x))
                                                              })
                                                        ],
                                                        className: "flex text-base font-normal w-9/12 break-all"
                                                      }),
                                                  logicCount > 0 ? JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("span", {
                                                                  children: "Logics",
                                                                  className: "text-gray-800 font-medium text-sm"
                                                                }),
                                                            JsxRuntime.jsx("span", {
                                                                  children: String(logicCount),
                                                                  className: "inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-green-600 rounded-full"
                                                                })
                                                          ],
                                                          className: "flex items-center gap-2"
                                                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                  disableAddLogic ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx("div", {
                                                          children: Caml_obj.equal(activeQuestion, x) ? JsxRuntime.jsx("img", {
                                                                  src: Image$ReactHooksTemplate.vectorDown
                                                                }) : JsxRuntime.jsx("img", {
                                                                  src: Image$ReactHooksTemplate.vectorRight
                                                                }),
                                                          className: "flex items-center justify-center rounded-md cursor-pointer " + (
                                                            Caml_obj.equal(activeQuestion, x) ? "bg-lavenderweb w-8 h-8 " : "bg-white w-8 h-8 "
                                                          ),
                                                          id: RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(x)),
                                                          onClick: (function (param) {
                                                              if (Caml_obj.equal(activeQuestion, x)) {
                                                                return Curry._1(setActiveQuestion, (function (param) {
                                                                              
                                                                            }));
                                                              } else {
                                                                return Curry._1(setActiveQuestion, (function (param) {
                                                                              return x;
                                                                            }));
                                                              }
                                                            })
                                                        })
                                                ],
                                                className: "flex justify-between items-center pb-3"
                                              }),
                                          Caml_obj.equal(activeQuestion, x) ? $$Array.of_list(Belt_List.mapWithIndex(survey.logics, (function (index, y) {
                                                        if (Caml_obj.equal(Logic$ReactHooksTemplate.trigger(y), {
                                                                TAG: "Question",
                                                                _0: x
                                                              })) {
                                                          return JsxRuntime.jsx("div", {
                                                                      children: JsxRuntime.jsx(LogicForm$ReactHooksTemplate.make, {
                                                                            survey: survey,
                                                                            logic: y,
                                                                            updateLogic: (function (param) {
                                                                                return Curry._1(updateSurvey, Survey$ReactHooksTemplate.setLogics(survey, List.mapi((function (i, logic) {
                                                                                                      if (i === index) {
                                                                                                        return param;
                                                                                                      } else {
                                                                                                        return logic;
                                                                                                      }
                                                                                                    }), Survey$ReactHooksTemplate.logics(survey))));
                                                                              }),
                                                                            deleteLogic: removeLogics
                                                                          }),
                                                                      className: "flex-col items-center mb-3 " + Curry._1(getBlurClass, index),
                                                                      draggable: true,
                                                                      onDragOver: (function (e) {
                                                                          Curry._2(handleDragOver, index, e);
                                                                        }),
                                                                      onDragStart: (function (e) {
                                                                          Curry._2(handleDragStart, index, e);
                                                                        }),
                                                                      onDrop: Curry._1(handleDragDrop, index)
                                                                    }, String(index));
                                                        } else {
                                                          return JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                                        }
                                                      }))) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                          Caml_obj.equal(activeQuestion, x) && !disableAddLogic ? JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("img", {
                                                                className: "h-14-px mr-2-px",
                                                                src: Image$ReactHooksTemplate.plusCircle
                                                              }),
                                                          "Add Logic"
                                                        ],
                                                        className: "flex bg-ghostwhite border border-gray-400 shadow-inner rounded py-2 px-3 text-xs font-normal cursor-pointer",
                                                        onClick: (function (param) {
                                                            var logicListCount = List.length(Belt_List.keep(Survey$ReactHooksTemplate.logics(survey), (function (x$1) {
                                                                        return Caml_obj.equal(Logic$ReactHooksTemplate.trigger(x$1), {
                                                                                    TAG: "Question",
                                                                                    _0: x
                                                                                  });
                                                                      })));
                                                            var newPriority = logicListCount + 1 | 0;
                                                            var logic = Survey$ReactHooksTemplate.emptyLogic(survey, newPriority, "Survey", x);
                                                            Curry._1(updateSurvey, Survey$ReactHooksTemplate.setLogics(survey, List.append(Survey$ReactHooksTemplate.logics(survey), {
                                                                          hd: logic,
                                                                          tl: /* [] */0
                                                                        })));
                                                            Curry._1(setActiveQuestion, (function (param) {
                                                                    return x;
                                                                  }));
                                                          })
                                                      }),
                                                  className: "mt-3 mb-3 flex items-center"
                                                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                        ],
                                        className: "bg-ghostwhiteblue w-full min-h-110-px my-2 p-4 rounded"
                                      }, RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(x)));
                          }), Survey$ReactHooksTemplate.questions(survey)))
              ],
              className: "flex flex-col px-16 py-8"
            });
}

var make = LogicPage;

exports.make = make;
/* react Not a pure module */
